/**
 * AP Invoices Demo — registers a (toolless) agent module on the Workflows pages
 * so Nami is available there.
 *
 * THROWAWAY DEMO CODE. The chat panel only mounts when the current page has
 * registered an agent module; the build tools themselves live in the global
 * `ApWorkflowToolsMount` (fired by the scripted interceptor). This just makes
 * the panel openable on the Workflows list + the demo build canvas so the user
 * can type "make me an AP processing workflow". Renders nothing. Mount on the
 * Workflows list page and the build canvas. Delete with src/demo/ap.
 */

import type { ModuleKey } from '@erp/rpc';
import type { FrontendToolDefinition } from '@/hooks/useFrontendTool';
import { useAgentModule } from '@/hooks/useAgentModule';
import { isApDemoMode } from '../demo-mode';
import { useApWorkflowDescribeAutostart } from './useApWorkflowDescribeAutostart';

const DEMO_MODULE_KEY = 'general' as ModuleKey;
// Stable empty array so `useAgentModule` doesn't re-register every render.
const NO_TOOLS: FrontendToolDefinition[] = [];

function Module() {
  useAgentModule({
    moduleKey: DEMO_MODULE_KEY,
    currentPage: 'ap-workflows-demo',
    tools: NO_TOOLS,
    headerTitle: 'Nami',
    placeholder: 'Try: "make me an AP processing workflow"',
  });
  // If we arrived here from the create-workflow "describe it" prompt, stream the
  // build turn into the chat once this module is registered.
  useApWorkflowDescribeAutostart();
  return null;
}

export function ApWorkflowAgentModule() {
  if (!isApDemoMode()) return null;
  return <Module />;
}
